import React, { useCallback } from 'react';
import { styled } from 'styled-components';
import { Button, Popover } from 'antd';
import { CategoryConfigurationDefinitionResponse } from '@ydistri/api-sdk';
import { useTemplateOrCalculation } from '../../../../../hooks/useTemplateOrCalculation';
import { TbX } from 'react-icons/tb';
import { isRootCategory } from '../../../../../lib/categories/categoriesLib';
import { AvailableModals, openModal } from '../../../../Modals/modalSlice';
import { ReduxState, useAppDispatch } from '../../../../../store';
import { useSelector } from 'react-redux';

const ClearButton = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.5rem;
  height: 1.5rem;
`;

const removeIcon = <TbX />;

export interface SpecialConfigurationSettings {
  categoryId: number;
  displayDeleteButton?: boolean | 'gap';
  italic?: boolean;
}

interface SpecialOptionDeleteButtonProps {
  categoryId: number;
  configurationDefinition: CategoryConfigurationDefinitionResponse;
  disabled?: boolean;
}

const SpecialOptionDeleteButton: React.FC<SpecialOptionDeleteButtonProps> = ({
  categoryId,
  configurationDefinition,
  disabled = false,
}) => {
  const dispatch = useAppDispatch();
  const openedModalId = useSelector((state: ReduxState) => state.modal.openedModal);
  const templateOrCalculation = useTemplateOrCalculation();
  const { type } = templateOrCalculation;
  const modalConfigurationDefinition = useSelector(
    (state: ReduxState) =>
      state.modal.modalData[AvailableModals.REMOVABLE_CONFIG_DELETE]?.configurationDefinition,
  );

  const openRemovableConfigDeletionModal = useCallback(() => {
    dispatch(
      openModal({
        type: AvailableModals.REMOVABLE_CONFIG_DELETE,
        data: {
          configurationDefinition,
        },
      }),
    );
  }, [configurationDefinition, dispatch]);

  const loading =
    openedModalId === AvailableModals.REMOVABLE_CONFIG_DELETE &&
    modalConfigurationDefinition?.fieldType === configurationDefinition.fieldType;

  return (
    <Popover
      content="Removing this option is possible only from root category."
      open={!isRootCategory(categoryId) && type === 'Template' ? undefined : false}
    >
      <ClearButton
        type="default"
        danger
        icon={removeIcon}
        onClick={openRemovableConfigDeletionModal}
        loading={loading}
        disabled={disabled}
      />
    </Popover>
  );
};

export default SpecialOptionDeleteButton;
